import Link from 'next/link';
import styles from './style.module.scss';
import { getKconfContent } from '@/services/common-next';
import { useEffect, useState } from 'react';
import FadeIn from '@/components/commonComponents/fadeIn';

type LatestNewsProps = {
  title: string;
  contents: NewsInfo[];
};

const NewsItem = (props: NewsInfo): JSX.Element => {
  const { title, image, description, link, tags } = props;
  return (
    <Link href={link} passHref className={styles['item']}>
      {/* NOTE: 这里的图片非工程内的，不用使用WebPNextImage组件 */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={image} alt="title" />
      <div className={styles['news-content']}>
        <div className={styles['text-group']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['description']}>{description}</div>
        </div>
        <div className={styles['tag-group']}>
          {tags.map((tag) => (
            <div className={styles['tag']} key={tag}>
              {tag}
            </div>
          ))}
        </div>
      </div>
    </Link>
  );
};

const LatestNews = (props: LatestNewsProps) => {
  const { title, contents } = props;
  const [news, setNews] = useState<NewsInfo[]>(contents);
  useEffect(() => {
    getKconfContent({
      key: 'website_activity_portal_config',
      name: 'platform_web',
      folder: 'streamlake',
    }).then((res) => {
      res && setNews(res);
    });
  }, []);
  return (
    <div className={styles['container']}>
      <FadeIn>
        <div className={styles['title']}>{title}</div>
      </FadeIn>
      <div className={styles['content']}>
        {news.map((item) => (
          <FadeIn key={item.title}>
            <NewsItem {...item} />
          </FadeIn>
        ))}
      </div>
    </div>
  );
};

export default LatestNews;
